import { register, applyAll } from '../../../../Javascript/Sysmex/Utils'

const DocumentList = el => {
  const filterForm = el.querySelector('form')
  const tempContainer = el.parentElement
  const resetButton = el.querySelector('.filterResetButton')
  // ToDO: Paginierungslogik ggf. in paginationAjax component auslagern
  const pagination = el.querySelector('[data-component="Pagination"]')
  const perPage = el.querySelector('[data-component="perPage"]')

  const params = new URLSearchParams(window.location.search)
  params.append('type', '1713847822')
  const baseURL = `${window.location.pathname}?${params.toString()}`

  const fetchContent = async (formData) => {
    if (window.showGlobalLoader) window.dispatchEvent(window.showGlobalLoader)
    // const parameters = Object.entries(params).map(([key, value]) => `tx_lrainterface_interface[${key}]=${value}`).join('&')

    try {
      const response = await fetch(baseURL, { // eslint-disable-line no-undef
        method: 'POST',
        cache: 'no-cache',
        body: formData
      })
      const respHTML = await response.text()

      return respHTML
    } catch (e) {
      if (window.hideGlobalLoader) window.dispatchEvent(window.hideGlobalLoader)
      console.error('ERROR', e)
    }
  }

  const submitForm = e => {
    e.preventDefault()
    const formData = new FormData(filterForm) // eslint-disable-line no-undef
    // formData.append('tx_mysysmexdocuments_documents[currentPage]', '2')
    replaceContent(formData)
  }

  const resetForm = e => {
    e.preventDefault()
    replaceContent()
  }

  const replaceContent = (formData = {}) => {
    fetchContent(formData)
      .then(res => {
        el.parentElement.innerHTML = res
        // ATM, applies all, even outside scope, but not MultiSelect
        applyAll(tempContainer) // needs a scope that is not getting duplicated
        el = null
        if (window.hideGlobalLoader) window.dispatchEvent(window.hideGlobalLoader)
      })
  }

  resetButton.addEventListener('click', resetForm)

  filterForm.addEventListener('submit', submitForm)

  if (pagination) {
    const paginationItems = pagination.querySelectorAll('[data-pagelink]')

    const changePage = newPage => {
      const formData = new FormData(filterForm) // eslint-disable-line no-undef
      formData.append('tx_mysysmexdocuments_documents[currentPage]', newPage)
      replaceContent(formData)
    }

    paginationItems.forEach(item => item.addEventListener('click', () => changePage(item.dataset.pagelink)))
  }

  if (perPage) {
    const perPagetems = perPage.querySelectorAll('input[type="radio"]')

    const changeItemsPerPage = perPageValue => {
      const formData = new FormData(filterForm) // eslint-disable-line no-undef
      formData.append('tx_mysysmexdocuments_documents[perPage]', perPageValue)
      replaceContent(formData)
    }

    perPagetems.forEach(item => item.addEventListener('click', () => changeItemsPerPage(item.value)))
  }
}

register('DocumentList', DocumentList)
